import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { IsRepairState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/is-repair";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const IsRepairDetails = memo(function IsRepairDetails({
  disabled,
}: ConditionTypeDetailsProps<IsRepairState>) {
  return (
    <Flex dir="column" gap="xs">
      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        Condition
      </Text>
      <Text fontSize="xxs" fontWeight="regular" textColor="tertiary">
        Applies when the return is marked as a repair.
      </Text>
    </Flex>
  );
});
